import type { GtmEventMap } from '~analytics/types/analyticsProvider';

import { EVENTS } from '~/constants/events';

/**
 * GTM dataLayer event map for the single google-tag-manager provider.
 *
 * Two shapes are expressed here:
 * - Legacy conversion events (nested: true) keep the { event, value } wrapper their
 *   existing Google Ads / GTM tags depend on.
 * - GA dataLayer Phase B events push flat. GA4 event names cannot contain dots, so
 *   unified.* events are renamed; payload property names stay identical to the Mixpanel
 *   payloads so both platforms report the same parameters. geo is derived GTM-side from
 *   the base `country`/`cluster` params.
 */
export const GTM_EVENT_MAP: GtmEventMap = {
  [EVENTS.ACCOUNT_REGISTER_COMPLETED]: { name: 'sign_up', nested: true },
  [EVENTS.LEARN_TOPIC_COMPLETED]: { name: 'tutorial_complete', nested: true },

  [EVENTS.UNIFIED_AUTH_SIGNUP_COMPLETED]: { name: 'account_register_completed' },
  [EVENTS.UNIFIED_AUTH_LOGIN_COMPLETED]: { name: 'account_login' },
  [EVENTS.UNIFIED_CONTENT_ASSET_STARTED]: { name: 'learn_topic_started' },
  [EVENTS.UNIFIED_CONTENT_ASSET_COMPLETED]: { name: 'learn_topic_completed' },
  // Google Ads keys its conversion actions on these two names, so the names and the conditions
  // under which they fire are fixed externally: `coach.*` is only where the trigger now reads
  // from. The narrowing stays here in the map rather than at the fire site — the Mixpanel event
  // reports every send and every rec click, and this is what turns that into a conversion.
  [EVENTS.COACH_MESSAGE_SENT]: {
    name: 'blinky_session_started',
    when: data => data.messageIndex === 1,
  },
  [EVENTS.COACH_RECOMMENDATION_CLICKED]: {
    name: 'blinky_career_explored',
    when: data => data.recommendationType === 'job' && !!data.entityId,
  },
  [EVENTS.UNIFIED_REWARDS_COINS_EARNED]: { name: 'rewards_earned' },
  [EVENTS.PHOENIX_REFERRAL_CODE_COPIED]: { name: 'referral_code_copied' },
  [EVENTS.UNIFIED_LEARN_EXPLORE_CARD_CLICKED]: { name: 'module_card_click' },
  [EVENTS.UNIFIED_LEARN_COLLECTIONS_CARD_CLICKED]: { name: 'module_card_click' },
};
